{
  "title": "Ҳисоб",
  "registerTitle": "Бақайдгирӣ",
  "subtitle": "Бо email, Google, телефон ё Telegram ворид шавед - ҳар усул ҳамон як ҳисоб ва ҳамёнро мекушояд.",
  "email": "Email",
  "password": "Рамз",
  "showPassword": "Нишон додан",
  "hidePassword": "Пинҳон кардан",
  "acceptTerms": "Қоидаҳои истифодаро қабул мекунам",
  "registerCta": "Бақайдгирӣ",
  "haveAccount": "Аллакай ҳисоб доред?",
  "needAccount": "Ҳисоб надоред?",
  "telegramHint": "Вуруди худкори Telegram Mini App фаъол аст (initData дар сервер санҷида мешавад).",
  "unavailable": "Аутентификатсия ҳанӯз фаъол нест",
  "telegramSoon": "Вуруд тавассути Telegram ба наздикӣ",
  "webSoon": "Вуруди веб ба наздикӣ",
  "googleDisabled": "Google login disabled until OAuth is configured",
  "googleReady": "Continue with Google",
  "smsDisabled": "SMS login disabled until an SMS provider is configured",
  "smsReady": "Continue with phone",
  "orEmail": "Email",
  "registerShort": "Сабти ном",
  "loginTitle": "Даромадан",
  "tabEmail": "Почта",
  "tabPhone": "Телефон",
  "emailPlaceholder": "E-mail",
  "phoneUnavailableTitle": "Даромад бо телефон ҳоло фаъол нест",
  "phoneUnavailableBody": "Хизмати SMS пайваст нашудааст. Бо почта ва парол давом диҳед.",
  "phonePlaceholder": "50 123 45 67",
  "phoneInvalidAz": "Рақами мобилии 9-рақамаи Озарбойҷонро ворид кунед (масалан, 50 123 45 67).",
  "casinoBonusInactive": "Кампания ҳоло фаъол нест",
  "socialMethods": "Воридшавии иҷтимоӣ",
  "orContinue": "ё",
  "continueWithTelegram": "Бо Telegram идома диҳед",
  "casinoBonus": "Бонуси казино",
  "noRegistrationBonus": "Ҳоло бонуси интихобшаванда барои сабти ном нест.",
  "promoToggle": "Илова кардани промокод",
  "promoPlaceholder": "Промокод",
  "promoHint": "Код ҳангоми сабти ном худкор татбиқ намешавад. Баъдтар дар саҳифаи Бонусҳо навишта метавонед.",
  "acceptTermsPrefix": "Ман ",
  "acceptTermsLink": "қоидаҳои истифода",
  "acceptTermsSuffix": "-ро хондам ва розӣ ҳастам.",
  "acceptTermsRequired": "Барои сабти ном қабули қоидаҳо лозим аст.",
  "termsMissingNote": "Лоиҳаи қоидаҳо дар саҳифаи /qaydalar аст. Барои нашр иҷозати алоҳида лозим. Барои бақайдгирӣ қайд кунед.",
  "registerSubmit": "Сабти ном",
  "loginSubmit": "Даромадан",
  "socialSoon": "Даромади веби Google ва Telegram ҳоло фаъол нест.",
  "haveAccountPrompt": "Аллакай ҳисоб дорам?",
  "haveAccountAction": "Даромадан",
  "needAccountPrompt": "Ҳисоб лозим аст?",
  "needAccountAction": "Сабти ном",
  "resetPassword": "Партолро барқарор кардан",
  "closeDialog": "Пӯшидан",
  "forgotLink": "Паролро фаромӯш кардед?",
  "forgotTitle": "Барқарор кардани парол",
  "forgotIntro": "Email-и ҳисобатонро ворид кунед. Агар он сабт шуда бошад, пайванди барқароркуниро мефиристем.",
  "forgotCta": "Фиристодани пайванд",
  "forgotSent": "Агар ҳисоб бо ин email вуҷуд дошта бошад, пайванд фиристода шуд. Қуттиҳои воридотӣ ва спамро санҷед.",
  "sendAgain": "Боз фиристодан",
  "emailDeliveryOff": "Дар ин сервер фиристодани мактуб ҳанӯз танзим нашудааст, мактуб намеояд.",
  "backToLogin": "Бозгашт ба воридшавӣ",
  "resetTitle": "Пароли нав интихоб кунед",
  "newPassword": "Пароли нав",
  "confirmPassword": "Паролро такрор кунед",
  "passwordsDontMatch": "Паролҳо мувофиқат намекунанд",
  "passwordRules": "Ҳадди ақал 8 аломат: ҳарфҳо якҷоя бо рақам ё аломатҳо.",
  "resetCta": "Нигоҳ доштани парол",
  "resetDone": "Парол иваз шуд. Ҳамаи сеансҳо баста шуданд - бо пароли нав ворид шавед.",
  "linkInvalid": "Пайванд нодуруст, мӯҳлаташ гузашта ё аллакай истифода шудааст.",
  "requestNewLink": "Дархости пайванди нав",
  "checking": "Санҷида мешавад...",
  "verifyTitle": "Тасдиқи email",
  "verifyIntro": "Барои тасдиқи суроғаи email тугмаро пахш кунед.",
  "verifyCta": "Тасдиқи email",
  "verifyDone": "Email тасдиқ шуд. Ташаккур!",
  "verifyResendHint": "Мактуби нави тасдиқро дар саҳифаи «Амният» дархост карда метавонед.",
  "securityTitle": "Амнияти ҳисоб",
  "emailVerified": "Тасдиқшуда",
  "emailNotVerified": "Тасдиқнашуда",
  "resendVerification": "Боз фиристодани мактуби тасдиқ",
  "verificationSent": "Мактуби тасдиқ фиристода шуд.",
  "verificationSentAfterRegister": "Ҳисоб сохта шуд. Ба email-и шумо пайванди тасдиқ фиристодем.",
  "phoneTitle": "Воридшавӣ бо телефон",
  "phoneLinkTitle": "Илова кардани рақами телефон",
  "phoneLabel": "Рақами телефон",
  "phoneHint": "Рақамҳои Озарбойҷонро ҳамчун 050 123 45 67 навиштан мумкин. Барои кишварҳои дигар бо + оғоз кунед.",
  "sendCode": "Фиристодани рамз",
  "codeLabel": "Рамз аз SMS",
  "codeSentTo": "Мо ба {{phone}} рамзи 6-рақама фиристодем.",
  "verifyCode": "Тасдиқ",
  "resendCode": "Боз фиристодани рамз",
  "resendIn": "Пас аз {{seconds}} сония боз фиристодан",
  "changeNumber": "Иваз кардани рақам",
  "phoneLinked": "Рақами телефон илова шуд.",
  "googleWorking": "Воридшавӣ бо Google...",
  "telegramWorking": "Воридшавӣ бо Telegram...",
  "telegramCancelled": "Воридшавӣ бо Telegram бекор карда шуд.",
  "googleLinked": "Ҳисоби Google пайваст шуд.",
  "googleCancelled": "Воридшавӣ бо Google бекор карда шуд.",
  "signInToLink": "Ба ҳисоби худ ворид шавед",
  "telegramWidgetUnavailable": "Воридшавӣ бо Telegram дар сайт пас аз танзими домени бот дастрас мешавад. Дар дохили Telegram Mini App шуморо худкор ворид мекунад.",
  "telegramLinked": "Telegram пайваст шуд.",
  "signInRequired": "Барои идоракунии амнияти ҳисоб ворид шавед.",
  "loginMethods": "Усулҳои воридшавӣ",
  "methodPassword": "Email ва парол",
  "methodGoogle": "Google",
  "methodPhone": "Телефон (SMS)",
  "methodTelegram": "Telegram",
  "linked": "Пайвастшуда",
  "notLinked": "Пайваст нашудааст",
  "link": "Пайваст кардан",
  "unlink": "Ҷудо кардан",
  "unlinked": "Усули воридшавӣ хориҷ шуд.",
  "lastMethodHint": "Ягона усули воридшавиро хориҷ кардан мумкин нест.",
  "unavailableProvider": "Танзим нашудааст",
  "changePasswordTitle": "Иваз кардани парол",
  "setPasswordTitle": "Гузоштани парол",
  "currentPassword": "Пароли ҷорӣ",
  "savePassword": "Нигоҳ доштани парол",
  "passwordSaved": "Парол нигоҳ дошта шуд. Сеансҳои дигар баста шуданд.",
  "changeEmailTitle": "Иваз кардани email",
  "newEmail": "Email-и нав",
  "saveEmail": "Нигоҳ доштани email",
  "emailSaved": "Email нав шуд. Суроғаи навро аз мактуб тасдиқ кунед.",
  "reauthTitle": "Тасдиқ кунед, ки ин шумоед",
  "reauthIntro": "Барои амният пеш аз идома паролро ворид кунед.",
  "reauthPasswordless": "Барои амният пеш аз идома дубора ворид шавед.",
  "reauthCta": "Идома додан",
  "mfaCode": "Рамзи аутентификатор",
  "signInAgain": "Дубора ворид шудан",
  "sessionsTitle": "Сеансҳо",
  "logout": "Баромадан",
  "logoutAll": "Баромадан аз ҳамаи дастгоҳҳо",
  "phoneNotSet": "Рақами телефон нест",
  "errors": {
    "invalid_credentials": "Email ё парол нодуруст аст.",
    "too_many_requests": "Кӯшишҳо аз ҳад зиёданд. Каме интизор шуда, боз кӯшиш кунед.",
    "email_taken": "Ин email аллакай сабт шудааст. Ба ҳисоб ворид шавед.",
    "password_too_short": "Парол хеле кӯтоҳ аст (ҳадди ақал 8 аломат).",
    "password_too_long": "Парол хеле дароз аст (ҳадди аксар 128 аломат).",
    "password_too_weak": "Парол заиф аст. Ҳарфҳоро бо рақам ё аломатҳо омехта кунед.",
    "password_too_common": "Ин парол хеле маъмул аст. Дигарашро интихоб кунед.",
    "password_contains_email": "Парол набояд номи email-и шуморо дошта бошад.",
    "invalid_or_expired_token": "Пайванд нодуруст, мӯҳлаташ гузашта ё аллакай истифода шудааст.",
    "invalid_password": "Парол нодуруст аст.",
    "invalid_email": "Email-и дурустро ворид кунед.",
    "email_not_set": "Ҳисоб email надорад.",
    "reauth_required": "Барои идома тасдиқ кунед, ки ин шумоед.",
    "password_not_set": "Ин ҳисоб парол надорад. Бо усули пайвастшуда дубора ворид шавед.",
    "email_required_for_password": "Пеш аз гузоштани парол email илова кунед.",
    "email_delivery_unavailable": "Фиристодани мактуб ҳанӯз танзим нашудааст.",
    "sms_disabled": "Воридшавӣ бо SMS ҳанӯз дастрас нест.",
    "phone_auth_disabled": "Бақайдгирӣ бо телефон ва воридшавӣ бо SMS муваққатан хомӯш аст.",
    "sms_delivery_failed": "SMS фиристода нашуд. Баъдтар боз кӯшиш кунед.",
    "invalid_phone": "Рақами дурусти телефонро ворид кунед.",
    "resend_cooldown": "Пеш аз дархости рамзи нав каме интизор шавед.",
    "otp_invalid": "Рамз нодуруст ё мӯҳлаташ гузаштааст.",
    "otp_expired": "Мӯҳлати рамз гузашт. Рамзи нав дархост кунед.",
    "otp_attempts_exceeded": "Рамзҳои нодуруст аз ҳад зиёданд. Рамзи нав дархост кунед.",
    "phone_in_use": "Ин рақам ба ҳисоби дигар тааллуқ дорад.",
    "phone_signin_conflict_retry": "Боз кӯшиш кунед.",
    "google_oauth_disabled": "Воридшавӣ бо Google ҳанӯз дастрас нест.",
    "telegram_oidc_disabled": "Воридшавии Telegram дар веб ҳанӯз дастрас нест.",
    "google_account_exists_link_required": "Ҳисоб бо ин email-и Google аллакай мавҷуд аст. Аввал ба он ворид шавед, баъд дар саҳифаи «Амният» Google-ро пайваст кунед.",
    "google_linked_to_other_account": "Ин ҳисоби Google ба ҳисоби дигари VBB PLAY пайваст аст.",
    "google_other_account_linked": "Ҳисоби дигари Google аллакай пайваст аст. Аввал онро ҷудо кунед.",
    "google_signin_conflict_retry": "Боз кӯшиш кунед.",
    "invalid_state": "Мӯҳлати кӯшиши воридшавӣ гузашт ё дар браузери дигар оғоз шудааст. Боз кӯшиш кунед.",
    "state_expired": "Мӯҳлати кӯшиши воридшавӣ гузашт. Боз кӯшиш кунед.",
    "nonce_mismatch": "Воридшавӣ бо Google санҷида нашуд. Боз кӯшиш кунед.",
    "invalid_id_token": "Воридшавӣ бо Google санҷида нашуд. Боз кӯшиш кунед.",
    "token_exchange_failed": "Google воридшавиро тасдиқ накард. Боз кӯшиш кунед.",
    "signing_key_unavailable": "Google муваққатан дастрас нест. Боз кӯшиш кунед.",
    "link_session_mismatch": "Ба ҳамон ҳисобе ворид шавед, ки пайвастшавиро оғоз кард.",
    "telegram_already_linked": "Ин Telegram ба ҳисоби дигари VBB PLAY пайваст аст.",
    "telegram_other_account_linked": "Telegram-и дигар аллакай пайваст аст. Аввал онро ҷудо кунед.",
    "telegram_payload_required": "Telegram маълумоти воридшавиро надод.",
    "auth_data_replayed": "Ин воридшавии Telegram аллакай истифода шудааст. Дубора ворид шавед.",
    "auth_data_expired": "Мӯҳлати воридшавии Telegram гузашт. Боз кӯшиш кунед.",
    "invalid_hash": "Воридшавӣ бо Telegram санҷида нашуд.",
    "last_login_method": "Ягона усули воридшавиро хориҷ кардан мумкин нест.",
    "account_suspended": "Ҳисоб боздошта шудааст. Ба дастгирӣ муроҷиат кунед.",
    "admin_email_change_disabled": "Email-и маъмурро танҳо оператор иваз карда метавонад.",
    "mfa_required": "Рамзро аз барномаи аутентификатор ворид кунед."
  }
}
